// extracted by mini-css-extract-plugin
export default {"container":"updateOrganizationsModal_container__iAtDZ"};